<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-dedication element-without-heading" id="vol-1-dedication">
<div class="text" id="vol-1-dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">For my lovely dad.</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Thank you for the memories.</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">I miss you every day.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol-001-dedication.vue?432e37b6